var _module_exports = "<ng-transclude></ng-transclude>\n<!-- <ng-transclude ng-transclude-slot=\"description\" class=\"slot-description\"></ng-transclude> -->\n";;
var path = '/workspace/src/app/common/ui/layout/layout.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;